import React, { useState, useEffect } from 'react';
import { authFetch } from '../../utils/api';
import DrawWindow from '../../DrawWindow';
import { INITX, SCALE } from '../../constants';

const ShowJsonImage = ({
  quoteId,
  quoteItemId,
  zoom = 1.0,
  doorData: propDoorData = null  // ← NEW: optional override
}) => {
  const [doorData, setDoorData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      if (!quoteId || !quoteItemId) return;

      try {
        const data = await authFetch(`/itemquotes/${quoteItemId}`);
        if (data?.doorData) {
          setDoorData(data.doorData);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    // Only fetch if no propDoorData
    if (propDoorData === null) {
      fetchData();
    } else {
      setDoorData(propDoorData);
    }
  }, [quoteId, quoteItemId, propDoorData]); // ← depend on propDoorData

  // Calculate the actual width of the scaled SVG
  const calculateImageWidth = () => {
    if (!doorData || !doorData.frameData) return 'auto';

    let x = doorData.frameData.X || 0;

    // For patio doors, calculate X from unitWidth_d since X may not be pre-computed
    if (doorData?.document?.type === 'patiodoors') {
      x = (parseFloat(doorData.frameData.unitWidth_d) || 72) * SCALE;
    }
    if (doorData?.document?.type === 'pleatedscreens') {
      x = (parseFloat(doorData.frameData.frameWidth) || 40) * SCALE;
    }

    const svgWidth = x + INITX + 65;
    const scaledWidth = svgWidth * zoom;

    return `${scaledWidth}px`;
  };

  return doorData && Object.keys(doorData).length > 0 ? (
    <div style={{ width: calculateImageWidth(), display: 'block', border: '0px solid blue' }}>
      <DrawWindow doorData={doorData} toLeft={0} zoom={zoom} flip={false} />
    </div>
  ) : (
    <div style={{ border: '1px solid yellow', padding: '10px' }}>
      {propDoorData === null ? 'Loading...' : 'No local data'}
    </div>
  );
};

export default ShowJsonImage;